/**
 * Generated by orval 🍺
 * Do not edit manually.
 * IST.Connect | v1
 * REST API backing the IST Connect web frontend. Provides endpoints to manage plugin configurations and inspect task execution results, logs, and dashboard data.
 * OpenAPI spec version: 1.0.0
 */
import type {
	CreateUntisISTBackendConfigRequest,
	Errors,
	GetUntisISTBackendConfigsParams,
	UntisISTBackendConfig,
	UntisISTBackendConfigCreatedResponse,
	UntisISTBackendConfigPage,
	UpdateUntisISTBackendConfigRequest,
} from "../model";

import { customFetch } from "../../customFetcher";

export const getCreateUntisISTBackendConfigUrl = () => {
	return `/istconnect-service-api/untis-istbackend-configs`;
};

/**
 * @summary Creates a new plugin config
 */
export const createUntisISTBackendConfig = async (
	createUntisISTBackendConfigRequest: CreateUntisISTBackendConfigRequest,
	options?: Parameters<typeof customFetch>[1],
): Promise<UntisISTBackendConfigCreatedResponse> => {
	const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]));
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<UntisISTBackendConfigCreatedResponse>(getCreateUntisISTBackendConfigUrl(), {
		...options,
		method: "POST",
		headers: { "Content-Type": "application/json-patch+json", ...getHeaders(options?.headers) },
		body: JSON.stringify(createUntisISTBackendConfigRequest),
	});
};

export const getGetUntisISTBackendConfigsUrl = (params?: GetUntisISTBackendConfigsParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/istconnect-service-api/untis-istbackend-configs?${stringifiedParams}`
		: `/istconnect-service-api/untis-istbackend-configs`;
};

/**
 * @summary Get all Untis ISTBackend configurations
 */
export const getUntisISTBackendConfigs = async (
	params?: GetUntisISTBackendConfigsParams,
	options?: Parameters<typeof customFetch>[1],
): Promise<UntisISTBackendConfigPage> => {
	return customFetch<UntisISTBackendConfigPage>(getGetUntisISTBackendConfigsUrl(params), {
		...options,
		method: "GET",
	});
};

export const getDeleteUntisISTBackendConfigUrl = (id: string) => {
	return `/istconnect-service-api/untis-istbackend-configs/${id}`;
};

/**
 * @summary Deletes a untis istbackend plugin config
 */
export const deleteUntisISTBackendConfig = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<Errors> => {
	return customFetch<Errors>(getDeleteUntisISTBackendConfigUrl(id), {
		...options,
		method: "DELETE",
	});
};

export const getGetUntisISTBackendConfigUrl = (id: string) => {
	return `/istconnect-service-api/untis-istbackend-configs/${id}`;
};

/**
 * @summary Get a untis istbackend plugin config
 */
export const getUntisISTBackendConfig = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<UntisISTBackendConfig> => {
	return customFetch<UntisISTBackendConfig>(getGetUntisISTBackendConfigUrl(id), {
		...options,
		method: "GET",
	});
};

export const getUpdateUntisISTBackendConfigUrl = (id: string) => {
	return `/istconnect-service-api/untis-istbackend-configs/${id}`;
};

/**
 * @summary Updates a untis ISTBackend plugin config
 */
export const updateUntisISTBackendConfig = async (
	id: string,
	updateUntisISTBackendConfigRequest: UpdateUntisISTBackendConfigRequest,
	options?: Parameters<typeof customFetch>[1],
): Promise<UntisISTBackendConfigCreatedResponse> => {
	const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]));
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<UntisISTBackendConfigCreatedResponse>(getUpdateUntisISTBackendConfigUrl(id), {
		...options,
		method: "PATCH",
		headers: { "Content-Type": "application/json-patch+json", ...getHeaders(options?.headers) },
		body: JSON.stringify(updateUntisISTBackendConfigRequest),
	});
};
